export default (props, vars) => () => window.close();
